class MetaInfoService {
  constructor(config) {
    this.defaultConfig = config;
  }

  generate(specificConfig = {}, potagerRoute) {
    // Ignore hash routes except for panel routes
    if (window.location.href.includes('#/') && (!potagerRoute?.meta?.isPanel)) {
      return undefined;
    }

    const config = { ...this.defaultConfig, ...specificConfig };

    // SEO fallback
    config.titleTemplate = config.title ? config.titleTemplate : '%s';
    config.title = config.title || 'Potager City';

    const metaInfos = {
      title: config.title, ...(config.titleTemplate && { titleTemplate: config.titleTemplate }),
      meta: [],
      link: [],
    };

    // Génération des balises meta
    metaInfos.meta.push(...this.generateMetaFromConfig(this.generateAppConfig(config), 'name'), ...this.generateMetaFromConfig(this.generateFacebookConfig(config), 'property'), ...this.generateMetaFromConfig(this.generateTwitterConfig(config), 'property'));

    // Ajout locale OpenGraph
    if (config.locale) {
      metaInfos.meta.push({
        property: 'og:locale',
        content: config.locale,
      });
    }

    // Ajout des metas/link additionnels
    metaInfos.link.push(...this.generateLinkConfig(config));
    metaInfos.meta.push(...this.generateMetaConfig(config));

    // Canonical propre
    if (potagerRoute && potagerRoute.href) {
      const canonicalUrl = new URL(window.location.origin + potagerRoute.href);
      canonicalUrl.hash = '';
      canonicalUrl.search = '';
      metaInfos.link.push({
        rel: 'canonical',
        href: canonicalUrl.toString(),
      });
    }

    // Suppression des doublons meta (par name/property/charset)
    metaInfos.meta = this.deduplicateMeta(metaInfos.meta);

    // Suppression des doublons link (par rel+href)
    metaInfos.link = this.deduplicateLink(metaInfos.link);

    // Suppression des balises meta vides
    metaInfos.meta = metaInfos.meta.filter(m => Object.values(m)
      .every(v => v !== undefined && v !== null && v !== ''));

    return metaInfos;
  }

  generateAppConfig(config) {
    return {
      title: config.title,
      description: config.description,
    };
  }

  generateFacebookConfig(config) {
    return {
      'og:title': config.title,
      'og:description': config.description,
      'og:type': config.fb?.type,
      'og:url': config.url,
      'og:image': config.image,
      'og:site_name': config.siteName,
      'fb:app_id': config.fb?.appId,
      'facebook-domain-verification': config.fb?.facebookDomainVerification,
    };
  }

  generateTwitterConfig(config) {
    return {
      'twitter:title': config.title,
      'twitter:description': config.description,
      'twitter:image': config.image,
      'twitter:card': config.twitter?.card,
      'twitter:url': config.url,
      'twitter:site': config.twitter?.site,
      'twitter:account_id': config.twitter?.accountId,
    };
  }

  generateLinkConfig(config) {
    return Array.isArray(config.link) ? [...config.link] : [];
  }

  generateMetaConfig(config) {
    return Array.isArray(config.meta) ? [...config.meta] : [];
  }

  // Génère des balises meta à partir d'un objet config, filtre les valeurs vides
  generateMetaFromConfig(metaObj, attrType) {
    return Object.entries(metaObj)
      .filter(([_, content]) => content) // Ignore les valeurs null/undefined/vides
      .map(([name, content]) => ({
        [attrType]: name,
        content,
      }));
  }

  // Suppression des doublons meta (par name/property/charset)
  deduplicateMeta(metaArr) {
    const seen = new Set();
    return metaArr.filter(meta => {
      const key = meta.name || meta.property || (meta.charset ? `charset:${meta.charset}` : undefined);
      if (!key) return true;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  // Suppression des doublons link (par rel+href)
  deduplicateLink(linkArr) {
    const seen = new Set();
    return linkArr.filter(link => {
      const key = `${link.rel || ''}:${link.href || ''}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }
}

// Nettoyage de l'URL pour le canonical par défaut
const cleanUrl = new URL(window.location.href);
cleanUrl.hash = '';
cleanUrl.search = '';

export default new MetaInfoService({
  titleTemplate: '%s - Potager City',
  description: 'La bonne variété au bon moment, sélectionnée avec soin auprès de producteurs passionnés. Choisissez votre 1er panier !',
  url: cleanUrl.toString(),
  siteName: 'Potager City',
  image: 'https://www.potagercity.fr/images/meta-default.jpg',
  fb: {
    type: 'website',
    appId: '123385305033743',
    facebookDomainVerification: 'iygj2ebonwtdrsvcdzz1mwhjfbwu8u',
  },
  twitter: {
    card: 'summary_large_image',
    site: '@potagercity',
    accountId: '180767737',
  },
  locale: 'fr_FR',
});
